import type { Bono } from '../types/content'

export const bonos: Bono[] = [
  {
    id: 'Bono 1',
    title: 'Matrix de Sustitutos Baratos',
    category: 'Referencia Rápida',
    description:
      '120 sustituciones en 8 categorías. Para consultar frente a la góndola en 5 segundos. 81% de ahorro promedio por sustitución.',
    value: 'Valor: $29.000 ARS',
  },
  {
    id: 'Bono 2',
    title: 'Planificador de Menú Semanal',
    category: 'Planificación',
    description:
      '4 semanas de menús completos con macros calculados, lista de compras integrada y timeline del Meal Prep dominical. Listo para imprimir.',
    value: 'Valor: $29.000 ARS',
  },
  {
    id: 'Bono 3',
    title: 'Guía Ayuno Intermitente 2.0',
    category: 'Optimización Metabólica',
    description:
      'Los 4 protocolos (12:12, 16:8, 18:6, OMAD), la ciencia del ayuno y el plan de 4 semanas de adaptación progresiva.',
    value: 'Valor: $29.000 ARS',
  },
  {
    id: 'Bono 4',
    title: 'Guía de Fermentados Caseros',
    category: 'Microbioma Activo',
    description:
      '8 fermentados con protocolo completo. 100x más bacterias que cápsulas de farmacia. Kéfir, chucrut, kimchi y más a $3.200 ARS/mes total.',
    value: 'Valor: $29.000 ARS',
  },
  {
    id: 'Bono 5',
    title: 'Recetario de Emergencia 15 Min',
    category: 'Anti-Delivery',
    description:
      '50 recetas en 15 minutos o menos. +30g proteína por plato, $900 ARS promedio. El backup definitivo contra el delivery.',
    value: 'Valor: $29.000 ARS',
  },
  {
    id: 'Bono 6',
    title: 'Guía Anti-Inflación Alimentaria',
    category: 'Contexto Argentino',
    description:
      '8 estrategias para mantener el costo estable con 289% de inflación. Rotación proteica, stock estratégico y estacionalidad activa.',
    value: 'Valor: $29.000 ARS',
  },
]
